<template>
  <router-view />
</template>

<script>

export default {
  name: 'Blank',
}

</script>

<style lang="scss" scoped>

</style>
